import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { NAV_GROUPS, SECTIONS, paths, type MenuGroup } from "@clevis/shared-types";
import { db } from "../lib/firebase";

// The company's menu groups (Roles & access → Company menu). Null until the
// owner saves one: everyone then gets the standard four groups.

export const STANDARD_GROUPS: MenuGroup[] = NAV_GROUPS.map((g) => ({
  id: g,
  label: g,
  items: SECTIONS.filter((s) => !s.parent && s.group === g).map((s) => s.id),
}));
/** Items the layout doesn't place (a page added after it was saved) land here. */
export const MORE_GROUP = { id: "more", label: "More" };

export function useMenuLayout(tenantId: string | null | undefined): { groups: MenuGroup[] | null; loaded: boolean } {
  const [groups, setGroups] = useState<MenuGroup[] | null>(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      doc(db, paths.tenantMenuLayout(tenantId)),
      (snap) => {
        const g = snap.get("groups") as MenuGroup[] | undefined;
        setGroups(g?.length ? g : null);
        setLoaded(true);
      },
      () => setLoaded(true),
    );
  }, [tenantId]);
  return { groups, loaded };
}

/** Which group each menu item sits in, and the groups in order. */
export function placeItems(layout: MenuGroup[] | null): { groupOf: Map<string, string>; groups: Array<{ id: string; label: string }> } {
  const groups = layout ?? STANDARD_GROUPS;
  const groupOf = new Map<string, string>();
  for (const g of groups) for (const id of g.items) if (!groupOf.has(id)) groupOf.set(id, g.id);
  return { groupOf, groups: [...groups.map((g) => ({ id: g.id, label: g.label })), MORE_GROUP] };
}
